import { Component, OnInit, ViewChild } from '@angular/core';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  LegendItemClickEvent,
  CategoryAxis,
  Legend,
  Series,
  SeriesLabelsContentArgs,
} from '@progress/kendo-angular-charts';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedService } from '../../shared/shared.service';

import {
  getSuperAdminDashboard,
  getSuperAdminDashboardRevenuDetials,
  getSuperAdminDashboardRevenuDetials_BasedOn_Date,
  resetSuperAdminDashboardState,
} from '../../store/dashboard/dashboard.actions';
import {
  getSuperadmindashboardResponse,
  getSuperadmindashboardRevenueOnDateResponse,
  getSuperadmindashboardRevenueResponse,
} from '../../store/dashboard/dashboard-selector';
import { formatDate, JsonPipe } from '@angular/common';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import {
  superadmin_graphColors,
  monthColors,
  UtilityType,
  SweetAlertIcon,
} from '../../shared/constants/enum';
import { SeriesClickEvent } from '@progress/kendo-angular-charts';
import { LoaderService } from '../../core/services/loader.service';
import { truncate } from 'fs';
import { LayoutService } from '../../core/services/layout.service';
import { BlobOptions } from 'buffer';
import { NotificationService } from '../../shared/notification.service';
import { DashboardService } from '../../core/services/dashboard.service';
export interface Project {
  projectId: string;
  projectName: string;
}
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexMarkers,
  ApexTitleSubtitle,
  ApexFill,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
  ApexStroke,
  ApexAnnotations,
  ApexNonAxisChartSeries,
} from 'ng-apexcharts';
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  stroke: ApexStroke;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  fill: ApexFill;
  annotations?: ApexAnnotations;
  colors: any;
};
interface XAxis {
  min: number; // Timestamp in milliseconds
  max: number; // Timestamp in milliseconds
}
@Component({
  selector: 'app-rp-dashboard',
  templateUrl: './rp-dashboard.component.html',
  styleUrl: './rp-dashboard.component.scss',
  standalone: false,
})
export class RpDashboardComponent {
  private getSuperadmindashboardResponse: Subscription = new Subscription();
  notificationCountData: any;
  GatewayInfoGraphData: any = [];
  deviceCountData: any;
  isSelectMonths = 'Current Month';
  deviceCountStatusLoading: boolean = true;
  deviceCountStatusNoDate: boolean = false;
  deviceCOuntinfographData: any[] = [];
  totalDeviceCOunt: number = 0;
  leakdetectiondevices: any[] = [];
  superAdminDashboardData: any;
  isLeakChartShow: boolean = false;
  commStatusTotalCount: number = 0;
  UtilityType = UtilityType;
  communicationStatusUtilities: any[] = [];
  gatewayStatusTotalCount: number = 0;
  totalResidentialUnits: number = 0;
  totalConsumers: number = 0;
  superAdminDashboardRevenueData: any = [];
  revenueData: any = [];
  convertedData: any[] = [];
  totalNotificationCount: number = 0;
  deviceNotificationGraphDataLoding: boolean = true;
  devicemonthlyNotificationGraphDataLoding: boolean = true;
  deviceNotificationStatusGraphNoData: boolean = false;
  isdailyLeakChart: boolean = true;
  categories: string[] = [];
  public updateOptionsData = {
    'Current Month': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1,
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0,
        ).getTime(),
      },
    },
    'Last Month': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1,
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0,
        ).getTime(),
      },
    },
    'Last Three Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          1,
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0,
        ).getTime(),
      },
    },
    'Last Six Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 5,
          1,
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0,
        ).getTime(),
      },
    },
  };
  public deviceNotificationGraphdata: { category: string; value: number }[] =
    [];
  monthlydeviceNotificationGraphdata: any[] = [];
  totalRevenueAmount: number = 0;
  datePickerConfig: Partial<BsDatepickerConfig>;
  superAdminDashboardRevenueDataBasedonDate: any;
  isRevenueDataBasedonDateloding: boolean = true;
  ConsumersNodata: boolean = false;
  ConsumersLoading: boolean = true;
  isRevenueLoding: boolean = true;
  isrevenuDataNodata: boolean = false;
  public yaxisUnits = '';
  public selectedDateRange: {
    startDate: string;
    endDate: string;
    projectIds: [];
  } | null = null;
  public selectedDateRangeLeak: {
    startDate: string;
    endDate: string;
  } | null = null;
  public filterProjectBillDates: any;
  revenuesProjectsList: any = [];
  revenuTotalProjectRevenueData: any = [];
  configData: any;
  isCollapsedSource: boolean = false;
  isSgldAdmin: boolean = false;

  public filterUtilitiesForDashboard(utilities: any[] | undefined): any[] {
    if (!utilities || !Array.isArray(utilities)) return [];
    return utilities.filter((u: any) => {
      const name = u?.name ?? u?.Name ?? '';
      return name.toString().trim().toLowerCase() !== 'ev';
    });
  }
  constructor(
    private layoutService: LayoutService,
    private store: Store,
    private router: Router,
    private sharedService: SharedService,
    private loaderService: LoaderService,
    private notificationService: NotificationService,
    private dashboardService: DashboardService,
  ) {
    this.getAllConfigData();
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - 6);
    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'YYYY-MM-DD', // Customize as needed
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
        minDate: sixMonthsAgo, // Set minimum date to 6 months ago
        maxDate: today, // Set maximum date to today
      },
    );
  }
  private _diff: number = 0;
  _days: number = 0;
  _hours: number = 0;
  _minutes: number = 0;
  _seconds: number = 0;
  private _trialEndsAt: any;
  public seriesVisible = true;
  public residentialUnitChart: any;
  selectedProject: Project[] = [];
  selectedRevenuWiseProject: any = [];
  dateRange: boolean = false;
  projectsList: Project[] = [];
  communicationStatusGraphData: any = [];
  @ViewChild('chart', { static: false }) chart?: ChartComponent;
  public chartOptions: ChartOptions = {
    series: [],
    chart: {
      type: 'area',
      height: 250,
    },
    dataLabels: { enabled: false },
    markers: { size: 0 },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: [] },
    yaxis: { title: { text: '' } },
    tooltip: {},
    colors: ['#008FFB'], // ✅ Add this line
    fill: { type: 'gradient' },
  };
  residentialUnitsData: any = [];
  consumerData: any = [];
  selectedRange = 'Current Month';
  colors = superadmin_graphColors;
  monthColors = monthColors;
  selectedBalance: string = 'total';
  selectedUtilityCommunication: any = 'All';
  balanceOptions = [
    { value: 'total', label: 'Total' },
    { value: 'postpaid', label: 'Postpaid' },
    { value: 'prepaid', label: 'Prepaid' },
  ];
  refreshDashboard() {
    this.gatewayStatusLoading = true;
    this.ResidentialUnitDataLoading = true;
    this.residenatilaNodata = false;
    this.gatewayStatusNoDate = false;
    this.ConsumersNodata = false;
    this.isrevenuDataNodata = false;
    this.ConsumersLoading = true;
    this.isRevenueLoding = true;

    this.communicationStatusGraphDataLoding = true;
    this.communicationStatusGraphNoData = false;
    if (this.isSgldAdmin) {
      this.initilApis();
      this.leakNotificationselectionChange('Current Month');
      return;
    }
    this.getDashboardData({ id: 'all', name: 'All' }, this.selectedProject);
    this.getRevenuedata(this.selectedRevenuWiseProject);
    this.selectionChange('Current Month');
  }
  ngOnInit(): void {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
    const role = currentUser?.currentUserRoleDetails?.role ?? '';
    this.isSgldAdmin = role.toString().toLowerCase() === 'sgldadmin';

    this.notificationService.emitNotificationUpdate();
    if (this.isSgldAdmin) {
      this.initilApis();
      this.leakNotificationselectionChange('Current Month');
    } else {
      this.getDashboardData({ id: 'all', name: 'All' }, this.selectedProject);
      this.getRevenuedata(this.selectedRevenuWiseProject);
      this.selectionChange('Current Month');
      this.initilApis();
      this.leakNotificationselectionChange('Current Month');
    }
    this.layoutService.isCollapsed$.subscribe((flag) => {
      this.isCollapsedSource = flag;
      console.log('Sidebar collapsed:', flag);
    });
  }
  initilApis() {
    // this.LeakDetectionIdentifier();
    this.dashboardService
      .getSuperAdmindeviceCountData(this.selectedProject)
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.deviceCountData = res.data;
            this.deviceCountInfomationData();
          } else {
            this.totalDeviceCOunt == 0;
            this.deviceCountStatusLoading = false;
            this.deviceCountStatusNoDate = true;
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });
  }
  LeakDetectionIdentifier(dateRange: any) {
    let request = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      ProjectIds: this.selectedProject,
    };
    console.log(request);
    this.dashboardService.getDeviceNotificationCountData(request).subscribe({
      next: (res) => {
        console.log(res);
        if (res.statusCode == 200) {
          console.log(res);
          this.notificationCountData = res.data;
          this.deviceNotificationData(this.notificationCountData);
        } else {
          this.deviceNotificationStatusGraphNoData = true;
        }
      },
      error: (err) => {
        this.deviceNotificationGraphDataLoding = false;
        this.deviceNotificationStatusGraphNoData = true;
        this.deviceNotificationGraphdata = [];
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }
  deviceCountInfomationData() {
    this.deviceCOuntinfographData = [];
    this.deviceCountStatusLoading = true;
    this.deviceCountStatusNoDate = false;
    this.totalDeviceCOunt = 0;

    const total = this.deviceCountData?.deviceStatusTotalCount;
    const projects = this.deviceCountData?.deviceStatusProjectCount;

    // Case 1: No project selected
    if (this.selectedProject.length === 0) {
      if (total) {
        this.totalDeviceCOunt = total.totalDevices;

        this.deviceCOuntinfographData = [
          {
            name: 'Only GSM Connected',
            value: total.gsmConnectedCount,
            color: this.colors[0],
          },
          {
            name: 'Both GSM and Wifi Connected',
            value: total.gsmWifiConnectedCount,
            color: this.colors[1],
          },
          {
            name: 'Only WIFI Connected',
            value: total.wifiConnectedCount,
            color: this.colors[2],
          },
          {
            name: 'Disconnected',
            value: total.disconnectedCount,
            color: this.colors[3],
          },
        ];
      } else {
        this.deviceCountStatusNoDate = true;
      }
    } else {
      // Case 2: Projects Selected

      if (!projects || projects.length === 0) {
        this.deviceCountStatusNoDate = true;
      } else {
        let gsmConnected = 0;
        let gsmWifiConnected = 0;
        let wifiConnected = 0;
        let disconnected = 0;

        this.selectedProject.forEach((projectId: any) => {
          const project = projects.find((p: any) => p.projectId === projectId);

          if (project) {
            gsmConnected += project.gsmConnectedCount;
            gsmWifiConnected += project.gsmWifiConnectedCount;
            wifiConnected += project.wifiConnectedCount;
            disconnected += project.disconnectedCount;
            this.totalDeviceCOunt += project.totalDevices;
          }
        });

        this.deviceCOuntinfographData = [
          { name: 'GSM Connected', value: gsmConnected, color: this.colors[0] },
          {
            name: 'GSM Wifi Connected',
            value: gsmWifiConnected,
            color: this.colors[1],
          },
          {
            name: 'WIFI Connected',
            value: wifiConnected,
            color: this.colors[2],
          },
          { name: 'Disconnected', value: disconnected, color: this.colors[3] },
        ];
      }
    }

    // Final loading state
    this.loaderService.setLoading(false);
    this.deviceCountStatusLoading = false;

    // If totals are zero — show no data
    if (this.totalDeviceCOunt === 0) {
      this.deviceCountStatusNoDate = true;
    }

    console.log('Final Data:', this.deviceCOuntinfographData);
  }

  deviceNotificationData(data: any) {
    this.initChart();
    console.log(this.isSelectMonths);
    if (
      this.isSelectMonths == 'Last Three Months' ||
      this.isSelectMonths == 'Last Six Months'
    ) {
      this.isLeakChartShow = false;
      // let monthlyWiseNotificationdata = this.convertToMonthlyConsumption(data);
      const monthlyWiseNotificationdata =
        this.leakconvertToMonthlyNotifications({
          notificationTotalCount: data.notificationTotalCount,
          dayWiseNotificationCount: data.dayWiseNotificationCount,
        });
      console.log(monthlyWiseNotificationdata);
      if (monthlyWiseNotificationdata.length > 0) {
        this.monthlyLeakNotificationChart(monthlyWiseNotificationdata);
      }
    } else {
      this.isLeakChartShow = true;
      this.loadConsumptionChart(data);
    }
  }
  initChart(): void {
    //  console.log('this.convertedData--------------->', this.convertedData);
    const startDate = this.selectedDateRangeLeak?.startDate
      ? new Date(this.selectedDateRangeLeak.startDate)
      : null;
    const dateDiff =
      startDate && this.selectedDateRangeLeak?.endDate
        ? new Date(this.selectedDateRangeLeak.endDate).getTime() -
          startDate.getTime()
        : 0;
    // console.log(startDate)
    //  console.log(this.selectedDateRange?.endDate)

    // Choose the date format based on the date difference (2 months in milliseconds)
    const dateFormat =
      dateDiff > 2 * 24 * 60 * 60 * 1000 ? 'dd MMM' : 'dd MMM HH:mm';
    //  console.log(dateFormat)

    this.chartOptions = {
      series: [
        {
          name: '',
          data: this.convertedData,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
        events: {
          mounted: (chart: any) => chart.windowResizeHandler(),
          dataPointMouseEnter: (event, chartContext, config) =>
            chartContext.chart.showTooltip(config.dataPointIndex),
          click: (event, chartContext, config) => {
            const dataPointIndex = config.dataPointIndex;
            if (dataPointIndex !== undefined) {
              // this.handleDataPointClick(config.seriesIndex, dataPointIndex);
            }
          },
        },
      },
      colors: ['#008FFB'], // ✅ Add this line

      dataLabels: { enabled: false },
      markers: { size: 0 },

      // ✅ Added stroke (Fix)
      stroke: {
        curve: 'smooth',
        width: 2,
      },

      xaxis: {
        type: 'datetime',
        min: startDate ? startDate.getTime() : undefined,
        max: this.selectedDateRangeLeak?.endDate
          ? new Date(this.selectedDateRangeLeak.endDate).getTime()
          : undefined,
        tickAmount: 3,
        title: { text: 'Dates' },
        labels: { format: dateFormat },
        tooltip: { enabled: false },
        crosshairs: { show: false },
      },

      yaxis: {
        title: { text: 'Count' },
      },

      tooltip: {
        x: { format: 'dd MMM yyyy' },
        y: { formatter: (value) => `${value}` },
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    };
  }
  leakconvertToMonthlyNotifications(data: any): any[] {
    // wrap into array if single object
    const items = Array.isArray(data) ? data : [data];

    return items.map((item: any) => {
      const totalNotificationCount = item.notificationTotalCount;

      const dailyData = item.dayWiseNotificationCount;
      if (!dailyData) return [];

      // Group by month
      const monthlyData = Object.keys(dailyData).reduce(
        (acc: any, date: string) => {
          const [year, month] = date.split('-');
          const monthKey = `${year}-${month}`;

          if (!acc[monthKey]) {
            acc[monthKey] = {
              year: Number(year),
              month: Number(month),
              monthName: new Date(`${year}-${month}-01`).toLocaleString(
                'default',
                {
                  month: 'long',
                },
              ),
              totalCount: 0,
            };
          }

          acc[monthKey].totalCount += dailyData[date];
          return acc;
        },
        {},
      );

      return {
        totalNotificationCount,
        monthlyWiseNotificationCount: Object.values(monthlyData),
      };
    });
  }
  ResidentialUnitDataLoading: boolean = true;
  residenatilaNodata: boolean = false;
  monthlyLeakNotificationChart(data: any) {
    console.log(data);
    this.devicemonthlyNotificationGraphDataLoding = true;
    this.monthlydeviceNotificationGraphdata = [];
    this.totalNotificationCount = data[0].totalNotificationCount;
    data[0].monthlyWiseNotificationCount.forEach((res: any, index: number) => {
      this.monthlydeviceNotificationGraphdata.push({
        category: res.monthName,
        value: Math.round(res.totalCount),
        colorString: this.colors[index],
      });
    });

    if (this.monthlydeviceNotificationGraphdata.length > 0) {
      this.devicemonthlyNotificationGraphDataLoding = false;
    }
  }
  loadConsumptionChart(notoficationData: any) {
    this.deviceNotificationGraphdata = [];
    const consumptionData = notoficationData?.dayWiseNotificationCount;
    this.totalNotificationCount = notoficationData?.notificationTotalCount;
    console.log(this.totalNotificationCount);
    console.log(consumptionData);
    for (const date in consumptionData) {
      // this.sumOfTotalConsumption = this.consuptiongraphdata[0].sumOfTotalConsumption
      if (consumptionData.hasOwnProperty(date)) {
        const value = consumptionData[date];
        this.deviceNotificationGraphdata.push({
          category: date,
          value: value,
        });
        // console.log(`category: "${date}", value: ${value}`);
      }
    }
    const convertedData = this.deviceNotificationGraphdata.map((item) => [
      new Date(item.category).getTime(),
      item.value,
    ]);

    console.log('Converted Data:', this.chartOptions.series);
    console.log(this.chartOptions);

    if (this.chartOptions.series && this.chartOptions.series[0].data) {
      this.chartOptions.series[0].data = [];

      //   console.log('convertedData test', convertedData);

      this.chartOptions.series[0].data = convertedData;
      this.convertedData = convertedData;

      this.deviceNotificationGraphDataLoding = false;
      this.initChart();
    }

    this.updateOptions(this.selectedRange);
    this.chart?.updateOptions(this.chartOptions, false, true, true); // Refresh chart

    setTimeout(() => {
      this.deviceNotificationGraphDataLoding = false;
    }, 200);
  }
  public updateOptions(option: keyof UpdateOptionsData): void {
    const optionData =
      this.updateOptionsData[option as keyof typeof this.updateOptionsData];
    if (optionData) {
      this.chart?.updateOptions(optionData, false, true, true);
    } else {
      console.log(`Option for '${option}' is undefined.`);
      // Handle undefined option case
    }
  }
  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/YYYY', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/YYYY', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  onDateRangeSelected(dateRange: (Date | undefined)[] | undefined): void {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = dateRange[0];
      const endDate = dateRange[1];

      // Format the dates to the desired format
      this.selectedDateRange = {
        startDate: formatDate(
          startDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          'en-US',
        ),
        endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
        projectIds: [],
      };

      this.getRevenuedataBasedOnDate(this.selectedDateRange);
    } else {
      this.selectedDateRange = {
        startDate: '',
        endDate: '',
        projectIds: [],
      };
      this.superAdminDashboardRevenueDataBasedonDate = [];
      this.isRevenueDataBasedonDateloding = false;
    }
  }

  public getColor(index: number): string {
    // console.log(this.monthColors[this.categories[index]]);
    return this.monthColors[this.categories[index]];
  }

  trackByUtilityId(index: number, utility: any): string {
    return utility.id;
  }
  getAllConfigData(): void {
    let payload = ['utilities', 'projects'];
    this.sharedService.getAllConfigData(payload).subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data?.data;
        this.projectsList = [...this.configData?.projects];

        this.configData.utilities = [
          { id: 'all', name: 'All' },
          ...this.configData.utilities, // Spread the existing utilities
        ];
        this.communicationStatusUtilities = this.filterUtilitiesForDashboard(
          this.configData.utilities,
        );

        this.selectedUtilityCommunication = this.configData.utilities[0].id;
        // console.log(this.configData.utilities);
      }

      // console.log('Types', this.projectsList);
    });
  }

  onMeterCommunicationStatusClick(event: any) {
    const seriesIndex = event.series.index; // or event.seriesIndex depending on your Kendo version
    // console.log('event.series.index---------->', event.category);

    let request = {
      value: event.category,
      type: 'superAdmin_Meter',
      utility: this.communicationStatusUtility,
    };
    this.router.navigate(['/meters'], {
      state: { meterRequest: request },
    });
  }

  ngOnDestroy() {
    this.store.dispatch(resetSuperAdminDashboardState());
    this.getSuperadmindashboardResponse.unsubscribe();
  }
  onChangeRevenueProject(data: any) {
    // console.log(data);
  }
  isSelected(item: any): boolean {
    // console.log(item);
    return (
      this.selectedRevenuWiseProject &&
      this.selectedRevenuWiseProject.includes(item.id)
    );
  }
  clearOption(item: any) {
    const index = this.selectedRevenuWiseProject.indexOf(item.id);
    if (index > -1) {
      this.selectedRevenuWiseProject.splice(index, 1);
      this.getRevenuedata(this.selectedRevenuWiseProject);
      // this.revenuDataOnProject(); // You can call your method to refresh the data
    }
  }

  revenuDataOnProject() {
    this.isRevenueLoding = true;
    this.revenueData = [];
    let projectsList: any = this.selectedRevenuWiseProject;
    this.getRevenuedata(projectsList);
    ///  this.getRevenuedataBasedOnDate(projectsList);
    // this.store.dispatch(getSuperAdminDashboardRevenuDetials({ projectsList }));
  }
  public revenuData() {
    // Initialize a map to store revenue data by month
    const monthlyRevenueMap = new Map<string, number>();

    // If no project is selected, use the full data
    if (this.selectedRevenuWiseProject.length === 0) {
      this.superAdminDashboardRevenueData.monthlyBillSummary.forEach(
        (entry: any) => {
          const month = entry.monthName;
          const revenueAmount = entry.totalBillAmount;

          // Accumulate revenue for each month
          if (monthlyRevenueMap.has(month)) {
            monthlyRevenueMap.set(
              month,
              monthlyRevenueMap.get(month)! + revenueAmount,
            );
          } else {
            monthlyRevenueMap.set(month, revenueAmount);
          }
        },
      );
    } else {
      // Loop through selected projects and accumulate revenue month-wise
      this.superAdminDashboardRevenueData.projectWiseRechargeData.forEach(
        (revenuProjet: any) => {
          if (revenuProjet) {
            let revenueDataJson = revenuProjet.monthlyRecharges;
            revenueDataJson.forEach((entry: any) => {
              const month = entry.monthName;
              const revenueAmount = entry.totalRechargeAmount;

              // Accumulate revenue for each month
              if (monthlyRevenueMap.has(month)) {
                monthlyRevenueMap.set(
                  month,
                  monthlyRevenueMap.get(month)! + revenueAmount,
                );
              } else {
                monthlyRevenueMap.set(month, revenueAmount);
              }
            });
          }
        },
      );
    }

    // Convert the map into an array for chart data in the desired JSON format
    this.revenueData = Array.from(monthlyRevenueMap.entries()).map(
      ([month, amount], index) => ({
        category: month, // Use month as the category
        value: amount.toFixed(2), // The total revenue for that month
        colorString: monthColors[month], // Color based on the month
      }),
    );
    if (this.revenueData.length > 0) {
      this.isRevenueLoding = false;
      this.isrevenuDataNodata = false;
    } else {
      this.isRevenueLoding = false;
      this.isrevenuDataNodata = true;
    }
    console.log('revenueData------>', this.revenueData);
  }

  getDashboardData(data: any, projectsList: any) {
    //let projectsList: any = [];
    // this.store.dispatch(resetSuperAdminDashboardState());
    // this.store.dispatch(getSuperAdminDashboard({ projectsList }));

    this.dashboardService.getSuperAdminDashboardData(projectsList).subscribe({
      next: (response) => {
        if (response && response.statusCode === 200) {
          this.loaderService.setLoading(false);
          this.gatewayStatusLoading = true;
          this.ResidentialUnitDataLoading = true;
          this.residenatilaNodata = false;
          this.gatewayStatusNoDate = false;
          this.ConsumersNodata = false;
          this.ConsumersLoading = true;

          this.communicationStatusGraphDataLoding = true;
          this.communicationStatusGraphNoData = false;
          console.log(response.data);
          this.superAdminDashboardData = response.data;
          // this.loaderService.setLoading(true);
          this.communicationStatusData(data);
          this.gateWayInformationData();
          this.getResidentialUnitData();
          this.listOfConsumers();
        } else {
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }

  openCalendar() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }

  clearDate() {
    this.selectedRange = 'Current Month';
    this.filterProjectBillDates = null; // Clear the selected date
    this.selectionChange(this.selectedRange);
  }

  onChangeProject(data: any) {
    console.log(data);
    console.log('------------->', this.selectedProject);
    let projectsList = this.selectedProject;
    this.isSelectMonths = 'Current Month';
    this.getDashboardData({ id: 'all', name: 'All' }, projectsList);
    this.initilApis();
    this.leakNotificationselectionChange('Current Month');
  }

  communicationStatusGraphDataLoding: boolean = true;
  communicationStatusGraphNoData: boolean = false;
  communicationStatusUtility: string = '';
  communicationStatusData(event: any) {
    console.log(event);
    this.communicationStatusUtility = event.name;
    this.selectedUtilityCommunication = event.id;
    let commCount = 0;
    let actualNonCommuCount = 0;
    let nonCommInactiveCount = 0;
    let nonCommMCBOffCount = 0;
    this.commStatusTotalCount = 0;
    // Selected utility name (replace this with your actual selected utility logic)
    const selectedUtilityName = event.name;
    console.log('selectedProject-->', this.selectedProject);
    this.communicationStatusGraphData = [];
    if (this.selectedProject.length === 0) {
      // Use total counts if no project is selected
      if (selectedUtilityName == 'All') {
        this.superAdminDashboardData?.communicationData?.totalCounts.forEach(
          (utility: any) => {
            this.commStatusTotalCount += utility.totalCount;
            commCount += utility.commCount;
            actualNonCommuCount += utility.actualNonCommuCount;
            nonCommInactiveCount += utility.nonCommInActiveCount;
            nonCommMCBOffCount += utility.nonCommMCBOffCount;
          },
        );
      } else {
        console.log(
          'utility',
          this.superAdminDashboardData.communicationData.totalCounts,
        );
        console.log('utility', selectedUtilityName);
        const utility =
          this.superAdminDashboardData.communicationData.totalCounts.find(
            (proj: any) => proj?.utilityMasterName === selectedUtilityName,
          );
        console.log('utility', utility);
        if (utility != undefined) {
          //  console.log('utility', selectedUtilityName);
          commCount = utility.commCount;
          actualNonCommuCount = utility.actualNonCommuCount;
          nonCommInactiveCount = utility.nonCommInActiveCount;
          nonCommMCBOffCount = utility.nonCommMCBOffCount;
          this.commStatusTotalCount = utility.totalCount;
        } else {
          this.commStatusTotalCount = 0;
        }
        // Ensure this is defined appropriately
      }
    } else {
      console.log(this.commStatusTotalCount);
      // Aggregate counts based on selected projects and utilityName
      // console.log(' this.selectedProject', this.selectedProject);
      this.selectedProject.forEach((projectId: any) => {
        const project =
          this.superAdminDashboardData.communicationData.projectCounts.find(
            (proj: any) => proj.projectId === projectId,
          );

        if (project && selectedUtilityName == 'All') {
          project.deviceCounts.forEach((device: any) => {
            commCount += device.commCount;
            actualNonCommuCount += device.actualNonCommuCount;
            nonCommInactiveCount += device.nonCommInActiveCount;
            nonCommMCBOffCount += device.nonCommMCBOffCount;
            this.commStatusTotalCount += device.totalCount; // Ensure this is defined appropriately
          });
        } else if (project) {
          project.deviceCounts.forEach((device: any) => {
            if (
              device.utilityName.toUpperCase() ===
              selectedUtilityName.toUpperCase()
            ) {
              commCount += device.commCount;
              actualNonCommuCount += device.actualNonCommuCount;
              nonCommInactiveCount += device.nonCommInActiveCount;
              nonCommMCBOffCount += device.nonCommMCBOffCount;
              this.commStatusTotalCount += device.totalCount; // Ensure this is defined appropriately
            }
          });
        }
      });
    }
    // console.log("Utility:", "refeshhhhh");

    let tempData = [
      {
        category: 'Communicating',
        value: commCount,
        colorString: this.colors[1],
        comment: 'Meters actively communicating as of today',
      },
      {
        category: 'Non Communicating',
        value: actualNonCommuCount,
        colorString: this.colors[2],
        comment: 'Meters not communicating as of today',
      },
      {
        category: 'Inactive',
        value: nonCommInactiveCount,
        colorString: this.colors[0],
        comment: 'Meters that have never been activated since installation',
      },
      {
        category: 'MCB Off',
        value: nonCommMCBOffCount,
        colorString: this.colors[3],
        comment: 'The MCB is turned off manually',
      },
    ];

    const getFilteredData = (categoryFilter: string | null) => {
      // Return filtered data excluding the specified categoryFilter
      return tempData.filter(
        (item) => categoryFilter && item.category !== categoryFilter,
      );
    };
    switch (selectedUtilityName) {
      case UtilityType.ELECTRICITY:
      case UtilityType.TriSource:
        // For Electricity, return all categories as is
        this.communicationStatusGraphData = tempData;
        break;

      case 'All':
        // For 'All', return all categories (same as tempData)
        this.communicationStatusGraphData = tempData;
        break;

      case UtilityType.WATER:
      case UtilityType.GAS:
        // case 'TriSource':
        // For Water, Gas, and TriSource, exclude "MCB Off" category
        this.communicationStatusGraphData = getFilteredData('MCB Off');
        break;

      default:
        // Default case to reset the data if the selected utility doesn't match any criteria
        this.communicationStatusGraphData = [];
        break;
    }
    console.log(this.commStatusTotalCount);
    if (this.commStatusTotalCount == 0) {
      this.communicationStatusGraphNoData = true;
      this.communicationStatusGraphDataLoding = false;
    } else {
      this.communicationStatusGraphNoData = false;
    }

    if (this.communicationStatusGraphData.length > 0) {
      this.communicationStatusGraphDataLoding = false;
    }
    // console.log("Utility:", "refeshhhhh");
    // console.log("djsjd------------->", this.communicationStatusGraphData);
  }

  get chartHeight(): number {
    if (this.isCollapsedSource) {
      return this.communicationStatusGraphData.length === 3 ? 223 : 203;
    } else {
      return this.communicationStatusGraphData.length === 3 ? 219 : 202;
    }
    // console.log(isMenuOpen)
  }

  gatewayStatusLoading: boolean = true;
  gatewayStatusNoDate: boolean = false;
  gateWayInformationData() {
    this.gatewayStatusLoading = true;
    this.gatewayStatusTotalCount = 0;
    let gatewayStatusInactiveCount = 0;

    if (this.selectedProject.length == 0) {
      this.gatewayStatusTotalCount =
        this.superAdminDashboardData.gatewayData.totalCounts.gatewayStatusTotalCount;
      gatewayStatusInactiveCount =
        this.superAdminDashboardData.gatewayData.totalCounts
          .gatewayStatusInactiveCount;
      if (this.gatewayStatusTotalCount == 0) {
        this.gatewayStatusNoDate = true;
      } else {
        this.gatewayStatusNoDate = false;
      }
    } else {
      this.selectedProject.forEach((projectId: any) => {
        const project =
          this.superAdminDashboardData.gatewayData.projectCounts.find(
            (proj: any) => proj.projectId === projectId,
          );
        if (project) {
          this.gatewayStatusTotalCount += project.totalCount;
          gatewayStatusInactiveCount += project.inactiveCount;
        }

        if (this.gatewayStatusTotalCount == 0) {
          this.gatewayStatusNoDate = true;
        } else {
          this.gatewayStatusNoDate = false;
        }
      });
    }

    this.GatewayInfoGraphData = [
      {
        value: this.gatewayStatusTotalCount - gatewayStatusInactiveCount,
        color: this.colors[1],
        name: `Active`,
      },
      {
        value: gatewayStatusInactiveCount,
        color: this.colors[0],
        name: `Inactive`,
      },
    ];
    if (this.GatewayInfoGraphData.length > 0) {
      this.gatewayStatusLoading = false;
    }
  }

  getResidentialUnitData() {
    this.totalResidentialUnits = 0;
    let occupiedUnits = 0;
    let unoccupiedUnits = 0;

    if (this.selectedProject.length == 0) {
      this.totalResidentialUnits =
        this.superAdminDashboardData.residentialUnitData.totalCounts.totalUnits;
      occupiedUnits =
        this.superAdminDashboardData.residentialUnitData.totalCounts
          .occupiedUnits;
      unoccupiedUnits =
        this.superAdminDashboardData.residentialUnitData.totalCounts
          .unoccupiedUnits;
      if (this.totalResidentialUnits == 0) {
        this.residenatilaNodata = true;
      } else {
        this.residenatilaNodata = false;
      }
    } else {
      this.selectedProject.forEach((projectId: any) => {
        const project =
          this.superAdminDashboardData.residentialUnitData.projectCounts.find(
            (proj: any) => proj.projectId === projectId,
          );
        if (project) {
          this.totalResidentialUnits += project.totalUnits;
          occupiedUnits += project.occupiedUnits;
          unoccupiedUnits += project.unoccupiedUnits;
        }
        if (this.totalResidentialUnits == 0) {
          this.residenatilaNodata = true;
        } else {
          this.residenatilaNodata = false;
        }
      });
    }

    this.residentialUnitsData = [
      {
        name: `Occupied units`,
        value: occupiedUnits,
        color: this.colors[1],
      },
      {
        name: `Unoccupied units`,
        value: unoccupiedUnits,
        color: this.colors[0],
      },
    ];
    if (this.residentialUnitsData.length > 0) {
      this.ResidentialUnitDataLoading = false;
    }
  }

  listOfConsumers() {
    // Initialize the counts for owners and tenants
    let owners = 0,
      tenents = 0;
    this.totalConsumers = 0;

    // Check if 'All Projects' is selected
    if (this.selectedProject.length == 0) {
      // Add the counts for all owners and tenants
      owners =
        this.superAdminDashboardData.ownerTenentCounts.totalCounts
          .totalOwnerCount;
      tenents =
        this.superAdminDashboardData.ownerTenentCounts.totalCounts
          .totalTenantCount;
      this.totalConsumers = owners + tenents;

      if (this.totalConsumers == 0) {
        this.ConsumersNodata = true;
      } else {
        this.ConsumersNodata = false;
      }
    } else {
      // Iterate through the selected projects
      // console.log('this.selectedProject', this.selectedProject);
      this.selectedProject.forEach((projectId: any) => {
        // Find the project in the consumer data
        const project =
          this.superAdminDashboardData.ownerTenentCounts.projectCounts.find(
            (proj: any) => proj.projectId === projectId,
          );

        //  console.log('Project data:', project);

        if (project) {
          // Accumulate the counts for the selected projects
          this.totalConsumers += project.ownerCount + project.tenantCount;
          owners += project.ownerCount;
          tenents += project.tenantCount;
        }
        if (this.totalConsumers == 0) {
          this.ConsumersNodata = true;
          this.ConsumersLoading = false;
        } else {
          this.ConsumersNodata = false;
        }
      });
    }

    // Update the consumerData array with the calculated values
    this.consumerData = [
      {
        name: `Owner`,
        value: owners,
        color: this.colors[1], // Assuming the color array is already defined
      },
      {
        name: `Tenant`,
        value: tenents,
        color: this.colors[0], // Assuming the color array is already defined
      },
    ];
    if (this.consumerData.length > 0) {
      this.ConsumersLoading = false;
    }

    // Log the final consumer data
    //  console.log('consumerData:', JSON.stringify(this.consumerData));
  }

  getRevenuedata(projectsList: any) {
    // this.loaderService.setLoading(true);
    // let projectsList: any = [];
    this.isRevenueLoding = true;
    this.isrevenuDataNodata = false;
    this.dashboardService
      .getSuperAdminDashboardRevenueData(projectsList)
      .subscribe({
        next: (response) => {
          if (response && response.statusCode === 200) {
            this.superAdminDashboardRevenueData = response.data;
            // this.processRevenueData(
            //   this.superAdminDashboardRevenueData.monthlyDateWiseResult.slice(-6)
            // );
            this.revenuTotalProjectRevenueData =
              this.superAdminDashboardRevenueData.monthlyBillSummary;
            this.revenuesProjectsList =
              this.superAdminDashboardRevenueData.projectWiseRechargeData;
            this.revenuData();
            this.totalRevenueAmount =
              this.superAdminDashboardRevenueData.totalRevenueAmount;
            this.loaderService.setLoading(false);
          } else {
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });

    //  this.store.dispatch(getSuperAdminDashboardRevenuDetials({ projectsList }));
  }

  getRevenuedataBasedOnDate(data: any) {
    this.isRevenueDataBasedonDateloding = true;
    this.dashboardService
      .getSuperAdminDashboardRevenueDataOnDate(data)
      .subscribe({
        next: (response) => {
          if (response && response.statusCode === 200) {
            this.superAdminDashboardRevenueDataBasedonDate = response.data;
            this.isRevenueDataBasedonDateloding = false;
            this.loaderService.setLoading(false);
          } else {
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR,
          );
        },
      });

    /* this.store.dispatch(
      getSuperAdminDashboardRevenuDetials_BasedOn_Date({
        daterange: this.selectedDateRange,
      })
    ); */
  }

  public labelContent(e: SeriesLabelsContentArgs): string {
    return e.value;
  }

  formatRevenueLabel = (e: any): string => {
    const amount = e.value;

    if (amount >= 10000000) {
      // Crores
      return (amount / 10000000).toFixed(2) + ' Cr';
    } else if (amount >= 100000) {
      // Lakhs
      return (amount / 100000).toFixed(2) + ' L';
    } else {
      // Thousands or less
      return amount.toLocaleString(); // e.g. "54,756"
    }
  };

  public months: Array<string> = [
    'Current Month',
    'Last Month',
    'Last Three Months',
    'Last Six Months',
    'Custom Range',
  ];
  public leakmonths: Array<string> = [
    'Current Month',
    'Last Month',
    'Last Three Months',
    'Last Six Months',
  ];
  legend: Legend = {
    position: 'bottom',
  };

  public onSeriesClick(e: SeriesClickEvent): void {
    // console.log('Clicked on:', e);
    // alert(`You clicked on ${e.category}: ₹${e.value}`);
  }
  public onLegendItemClick(e: LegendItemClickEvent): void {
    /* Do not hide the series on legend click */
    e.preventDefault();

    /* Hide the series manually */
    this.seriesVisible = !this.seriesVisible;
  }

  getDays(t: number) {
    return Math.floor(t / (1000 * 60 * 60 * 24));
  }

  getHours(t: number) {
    return Math.floor((t / (1000 * 60 * 60)) % 24);
  }

  getMinutes(t: number) {
    return Math.floor((t / 1000 / 60) % 60);
  }

  getSeconds(t: number) {
    return Math.floor((t / 1000) % 60);
  }

  selectionChange(event: any) {
    const selectedOption = event;
    this.dateRange = false;
    const now = new Date();
    let startDate: Date;
    let endDate: Date = now;

    this.filterProjectBillDates = null;
    switch (selectedOption) {
      case 'Current Month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = now; // Current date of the current month
        endDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Month':
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of last month
        break;
      case 'Last Three Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of the previous month
        break;
      case 'Last Six Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of the previous month
        break;
      /* case 'One Year':
        startDate = new Date(now.getFullYear() - 1, now.getMonth(), 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of the previous month
        break; */
      case 'Custom Range':
        this.dateRange = true;
        // Implement custom range logic here
        return;
      default:
        startDate = now;
        endDate = now;
    }

    this.selectedDateRange = {
      startDate: formatDate(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      projectIds: [],
    };

    this.getRevenuedataBasedOnDate(this.selectedDateRange);
    // console.log(this.selectedDateRange);
  }
  leakNotificationselectionChange(event: any) {
    const selectedOption = event;
    this.dateRange = false;
    const now = new Date();
    let startDate = new Date(now);
    let endDate = new Date(now);

    this.filterProjectBillDates = null;

    switch (selectedOption) {
      case 'Current Month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date();
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'Last Month':
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'Last Three Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'Last Six Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999);
        break;

      case 'Custom Range':
        this.dateRange = true;
        return;
    }

    this.selectedDateRangeLeak = {
      startDate: formatDate(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
    };
    console.log(
      'Selected Date Range for Leak Detection:',
      this.selectedDateRangeLeak,
    );
    this.LeakDetectionIdentifier(this.selectedDateRangeLeak);
  }
}
interface MonthlyConsumption {
  year: number;
  month: number;
  monthName: string;
  totalConsumptionForUtility: number;
}

interface UtilityData {
  utilityMasterName: string;
  sumOfTotalConsumption: any;
  totalLeakByDay: DailyLeaks;
}
interface DailyLeaks {
  [date: string]: number; // The date is a string and the consumption is a number
}
interface UpdateOptionsData {
  [key: string]: {
    xaxis: XAxis;
  };
}
